import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'

interface IProps {
    handleTypeChange?: (mapType: string) => void
    handleEnableTransit?: (transit: boolean) => void
    mapRef: any
}

const MAP_ROAD = 'roadmap'
const MAP_HYBRID = 'hybrid'
const MAP_TRANSIT = 'transit'

const layer = {
    MAP_ROAD: { type: MAP_ROAD, url: 'https://maps.gstatic.com/tactile/layerswitcher/ic_default-1x.png' },
    MAP_HYBRID: { type: MAP_HYBRID, url: 'https://maps.gstatic.com/tactile/layerswitcher/ic_satellite-1x.png' },
    MAP_TRANSIT: { type: MAP_TRANSIT, url: 'https://maps.gstatic.com/tactile/layerswitcher/ic_traffic-1x.png' }
}

export const LayersMenu = ({ mapRef }: IProps): JSX.Element => {
    const [openMenu, setOpenMenu] = useState(false)
    const [layerSelected, setLayerSelected] = useState(layer.MAP_ROAD)
    const [trafficIsActive, setTrafficIsActive] = useState(false)
    const [trafficLayer, setTrafficLayer] = useState<google.maps.TrafficLayer>(null)

    useEffect(() => {
        if (mapRef != null) {
            setTrafficLayer(new google.maps.TrafficLayer())
        }
    }, [mapRef])

    const handleEnableTraffic = (enable: boolean): void => {
        setTrafficIsActive(enable)

        if (mapRef.current) {
            trafficLayer.setMap(enable ? mapRef.current : null)
        }
    }

    const selectLayer = (layer: any) => {
        setLayerSelected(layer)
        mapRef.current.setMapTypeId(layer.type)
    }

    return (
        <MainDiv img={layerSelected.url} onClick={() => setOpenMenu(!openMenu)}>
            {openMenu && (
                <TypeDiv>
                    <TitleDiv>
                        <span>{i18n('Map type')}</span>
                        <span>{i18n('Map details')}</span>
                    </TitleDiv>
                    <div className={'container-div'}>
                        <TypeOpt
                            mapType={layerSelected.url}
                            img={layer.MAP_ROAD.url}
                            onClick={() => selectLayer(layer.MAP_ROAD)}
                        >
                            <div></div>
                            <span>Default</span>
                        </TypeOpt>
                        <TypeOpt
                            mapType={layerSelected.url}
                            img={layer.MAP_HYBRID.url}
                            onClick={() => selectLayer(layer.MAP_HYBRID)}
                        >
                            <div></div>
                            <span>{i18n('Satellite')}</span>
                        </TypeOpt>
                        <DividerV />
                        <TypeOpt
                            enableTransit={trafficIsActive}
                            img={layer.MAP_TRANSIT.url}
                            onClick={() => handleEnableTraffic(!trafficIsActive)}
                        >
                            <div></div>
                            <span>{i18n('Transit')}</span>
                        </TypeOpt>
                    </div>
                </TypeDiv>
            )}
        </MainDiv>
    )
}

export default LayersMenu

const MainDiv = styled.div`
    height: 50px;
    width: 50px;
    position: relative;
    right: 10px;
    top: 10px;
    z-index: 100;
    background: ${props => `url(${props.img})`};
    cursor: pointer;
    border: 1px solid #ffffff;
    border-radius: 3px;

    .map-type-span {
        float: left;
    }

    .map-details-span {
        float: right;
    }
`

const TitleDiv = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
`

const TypeDiv = styled.div`
    display: flex;
    background-color: #ffffff;
    position: absolute;
    top: 60px;
    right: 0px;
    padding: 10px;
    flex-direction: column;

    .container-div {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
`
const TypeOpt = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    align-items: center;

    div {
        height: 50px;
        width: 50px;
        background: ${props => `url(${props.img})`};
        border-radius: 10px;
        border: 1px solid #dddee1;
        ${props =>
            props.mapType == props.img || props.enableTransit
                ? 'filter: drop-shadow(0px 2px 4px rgba(54, 65, 89, 0.25));'
                : ''}
    }

    span {
        margin-top: 10px;
        font-size: 13px;
        ${props => (props.mapType == props.img || props.enableTransit ? 'font-weight:600;' : '')}
    }
`

const DividerV = styled.div`
    height: 75px;
    width: 1px;
    border: 1px solid #dddee1;
`
